// extracted by mini-css-extract-plugin
export default {"description":"Description_description__4ZfgF","description__link":"Description_description__link__jI4Sy"};